import React, { useEffect, useRef, useState } from 'react';
import { QrReader } from 'react-qr-reader';
import QrScanner from "react-qr-scanner";
import swal from 'sweetalert';
import "./scanneurCodeQr.css"
import { useNavigate } from 'react-router-dom';
import { clients_services } from '../../services/clients_services';
import toast from 'react-hot-toast';
const ScanneurCodeQr = () => {
    // Navigations
    const navigate = useNavigate()
    const home = () => {
        navigate('/company/dashboad');
    };
    const list_client = () => {
        navigate('/company/list/client');
    };
    const qrFileRef = useRef(null); // Réf pour le lecteur QR de fichier
    const [id, setId] = useState(''); // 
    const [wait, setWait] = useState(true)
    const [client, setClient] = useState('');
    const [quantity, setQuantity] = useState(0);
    const [typeIntervention, setTypeIntervention] = useState('');
    const [scanKey, setScanKey] = useState(0);

    const previewStyle = {
        // height: 260,
        width: "100%"
    };

    useEffect(() => {
        if (id !== '') {
            clients_services.scanClient1(id)
                .then((res) => {
                    console.log("scanCodeQr::: ", res);

                    setTypeIntervention(res.data.typeIntervention);

                    if (res.data.typeIntervention === 2) {
                        // Ouvrir la modal Bootstrap
                        const modal = new window.bootstrap.Modal(document.getElementById('modal-scan'));
                        modal.show();
                        return;
                    } else if (res.status === 200) {
                        setScanKey((prevKey) => prevKey + 1);
                        swal({
                            text: "Action du client correctement enregistrée",
                            icon: "success",
                            button: "Fermer",
                        });
                    } else if (res.status === 201) {
                        setScanKey((prevKey) => prevKey + 1);
                        swal({
                            text: "Félicitations pour votre fidélité, le bonus est atteint.",
                            icon: "success",
                            button: "Fermer",
                        });
                    }

                    // Vérifier si un ID est toujours disponible
                    if (id !== '') {
                        clients_services.getClient(id)
                            .then((res) => {
                                console.log("ClientDetailRes:", res.data.client);
                                setClient(res.data.client);

                                // Enregistrer automatiquement les informations
                                clients_services.addScanHistory(res.data.client.id, {
                                    id: res.data.client.id,
                                    structureId: res.data.client.StructureId,
                                    nomClient: res.data.client.nom,
                                    prenomClient: res.data.client.prenom,
                                    localisationClient: res.data.client.localisation,
                                    nbrVisiteClient: res.data.client.trace, // Augmenter le nombre de visites
                                    date: new Date(), // Date actuelle
                                    heure: new Date().toLocaleTimeString(), // Heure actuelle
                                })
                                    .then((res) => {
                                        console.log('getHistoryRes ::', res.data);
                                        console.log("Informations du client enregistrées avec succès.");
                                    })
                                    .catch((err) => {
                                        console.error("Erreur lors de l'enregistrement des informations :", err);
                                    });
                            })
                            .catch((err) => {
                                console.error("Erreur lors de la récupération des détails du client :", err);
                            });
                    }
                })
                .catch((err) => {
                    console.error("Erreur lors du scan :", err);
                    if (err.response) {
                        if (err.response.status === 403) {
                            toast.error("Le client n'appartient pas à la structure");
                        } else if (err.response.status === 404) {
                            swal({
                                text: "Client introuvable.",
                                icon: "error",
                                button: "Fermer",
                            });
                        } else if (err.response.status === 400) {
                            navigate("/auth/loginCompany");
                        } else if (err.response.status === 401) {
                            swal({
                                text: "Votre compte n'existe pas",
                                icon: "error",
                                button: "Fermer",
                            });
                        }
                    }
                });
        }
    }, [id, navigate]);


    const onChange = (e) => {
        setQuantity({
            ...quantity,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = (e) => {
        e.preventDefault();
        return clients_services.scanClient2(id, quantity)
            .then((res) => {
                if (res.status === 200 || 201) {
                    if (id !== '') {
                        clients_services.getClient(id)
                            .then((res) => {
                                // console.log("ClientDetailRes:", res.data.client);
                                setClient(res.data.client)
                                // Vérifier si un ID est toujours disponible
                                if (id !== '') {
                                    clients_services.getClient(id)
                                        .then((res) => {
                                            console.log("ClientDetailRes:", res.data.client);
                                            setClient(res.data.client);

                                            // Enregistrer automatiquement les informations
                                            clients_services.addScanHistory(res.data.client.id, {
                                                id: res.data.client.id,
                                                structureId: res.data.client.StructureId,
                                                nomClient: res.data.client.nom,
                                                prenomClient: res.data.client.prenom,
                                                localisationClient: res.data.client.localisation,
                                                nbrVisiteClient: res.data.client.trace, // Augmenter le nombre de visites
                                                date: new Date(), // Date actuelle
                                                heure: new Date().toLocaleTimeString(), // Heure actuelle
                                            })
                                                .then((res) => {
                                                    console.log('getHistoryRes ::', res.data);
                                                    console.log("Informations du client enregistrées avec succès.");
                                                })
                                                .catch((err) => {
                                                    console.error("Erreur lors de l'enregistrement des informations :", err);
                                                });
                                        })
                                        .catch((err) => {
                                            console.error("Erreur lors de la récupération des détails du client :", err);
                                        });
                                }
                            })
                            .catch((err) => {
                                console.error("err :", err);
                                if (err.response) {
                                    if (err.response.status === 400) {
                                        navigate("/auth/loginCompany");
                                    }
                                }
                            });
                    }
                }
                if (res.status === 200) {
                    swal({
                        text: "Action du client correctement enregistrer",
                        icon: "success",
                        button: "Fermer",
                    });
                } else if (res.status === 201) {
                    swal({
                        text: "Félicitations pour votre fidélité, le bonus est atteint.",
                        icon: "success",
                        button: "Fermer",
                    });
                }
                setScanKey(scanKey + 1);
                // Fermer la modal
                document.getElementById('modal-scan').classList.remove('show');
                document.getElementById('modal-scan').setAttribute('aria-hidden', 'true');
                document.body.classList.remove('modal-open');
                document.querySelector('.modal-backdrop').remove();
                setQuantity({
                    qte: ""
                });
            })
            .catch((err) => {
                console.error("err:", err);
                if (err.response) {
                    if (err.response.status === 403) {
                        swal({
                            text: "Le client n'appartient pas a la structure",
                            icon: "error",
                            button: "Fermer",
                        });
                    } else if (err.response.status === 404) {
                        swal({
                            text: "Client introuvable.",
                            icon: "error",
                            button: "Fermer",
                        });
                    } else if (err.response.status === 400) {
                        navigate("/auth/loginCompany");
                        swal({
                            text: "Votre séssion a expiré, veillez vous connecter",
                            icon: "error",
                            button: "Fermer",
                        });
                    } else if (err.response.status === 401) {
                        swal({
                            text: "Votre compte n'existe pas",
                            icon: "error",
                            button: "Fermer",
                        });
                    }
                }
            });
    };

    const handleScanFile = (result) => {
        if (result) {
            try {
                const parsedData = JSON.parse(result.text);
                const { Id } = parsedData;

                // Récupérer uniquement l'ID et le mettre à jour dans l'état
                setId(Id);

                console.log("Résultat du scan :", result);
                setScanKey(scanKey + 1);

            } catch (error) {
                console.error("error::", error);
                swal({
                    text: "QR Code invalide.",
                    icon: "error",
                    button: "Fermer",
                });
            }
        }
    };

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Gestion des clients</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item link"><a onClick={home}>Acceuil</a></li>
                                <li className="breadcrumb-item link"><a onClick={list_client}>Clients</a></li>
                                <li className="breadcrumb-item active">Scan Code Qr</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card mt-3">
                                <div className="card-header">
                                    <h5 className='card-title'><i className="fas fa-qrcode mr-2"></i>Scan des codes Qr</h5>

                                    <button className="btn btn-light text-success shadow btn-xs" onClick={home} title='Retour au tableau de bord' style={{ position: 'relative', float: 'right' }}>
                                        <i className="mr-1 fas fa-arrow-left" />
                                        Retour
                                    </button>
                                </div>
                                <div className="card-body">
                                    <div className="row ">
                                        <div className="col-md-7 shadow ">
                                            {/* <QrReader className='codeReader'
                                                ref={qrFileRef}
                                                delay={300}
                                                onResult={id === '' ? handleScanFile : undefined}
                                                legacyMode={false}
                                                constraints={{
                                                    video: { facingMode: { exact: "environment" } },
                                                }}
                                            /> */}
                                            <QrScanner
                                                className='codeReader'
                                                key={scanKey}
                                                ref={qrFileRef}
                                                delay={300}
                                                legacyMode={false}
                                                style={previewStyle}
                                                onScan={handleScanFile}
                                                constraints={{
                                                    video: { facingMode: "environment" },
                                                }}
                                            />

                                        </div>
                                        {
                                            client ?
                                                <div className="col-md-5 infoDetail">
                                                    <div className="fw-bold name mt-2"><h4><strong className='capitalize shadow px-2 py-2'>{client.nom + " " + client.prenom}</strong></h4></div>

                                                    <div className="mt-3"><i className='fas fa-map-marker-alt mr-2 ml-2'></i>{client.localisation}</div>

                                                    <div className="mt-3"><i className='fas fa-phone mr-2 ml-2'></i> (+237) {client.numeroTel} </div>

                                                    <div className="mt-3"><i className={typeIntervention ? "fas fa-dumbbell mr-2 ml-2" : "fas fa-infinity mr-2 ml-2"}></i> {client.trace} <strong>{typeIntervention ? "Kg" : "Visite(s)"}</strong></div>


                                                    <div className="mt-3">
                                                        {
                                                            client.sexe === 'masculin' ? <i className="fas  mr-2 ml-2 fa-mars"></i> :
                                                                client.sexe === 'feminin' ? <i className="fas  mr-2 ml-2 fa-venus"></i> : ''
                                                        }
                                                        {client.sexe}
                                                    </div>

                                                    <div className="mt-3 "> Bonus atteint : <strong className='text-success'>{client.bonus}</strong></div>
                                                </div>
                                                : <p className='ml-3'>En attente des informations...</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* modals */}
            {/* update client quntity modal */}
            <div className="modal fade" id="modal-scan">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Veuillez rensigner la quantite</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form className="row form" onSubmit={onSubmit}>
                            <div className="modal-body">
                                <div className="container">
                                    <div className="row ">
                                        <input type="number" name='qte' value={quantity.qte}
                                            onChange={onChange}
                                            placeholder='Veillez entrer la quantité' className="form-control mt-3" />
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <button type="button" className="btn btn-secondary btn-sm" data-dismiss="modal" title='Fermer'><i className='fas fa-times f-3 mr-1'></i>Fermer</button>
                                        <div className="d-flex">
                                            {
                                                wait ?
                                                    <button type="submit" className="btn btn-success btn-sm" title='Enregistrer'> <i className='fas fa-plus mr-1 f-3'></i>Enregistrer</button>
                                                    :
                                                    <button className="btn btn-succes btn-sm"> <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Enregistrement..</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default ScanneurCodeQr;